import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=24e8362e&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=24e8362e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8362e",
  null
  
)

export default component.exports